import React from 'react';
import AdminNavigation from '../AdminNavigation';
import { Shield } from 'lucide-react';

/**
 * 관리자 페이지의 공통 레이아웃 컴포넌트
 * @param {Object} props
 * @param {string} props.title - 페이지 제목
 * @param {string} props.description - 페이지 설명
 * @param {React.ReactNode} props.icon - 페이지 아이콘 (선택사항)
 * @param {React.ReactNode} props.actions - 헤더 우측에 표시할 액션 버튼들 (선택사항)
 * @param {React.ReactNode} props.children - 페이지 콘텐츠
 * @param {boolean} props.isAdmin - 관리자 권한 여부
 * @param {boolean} props.loading - 로딩 상태
 */
const AdminLayout = ({ 
  title, 
  description, 
  icon = <Shield className="h-8 w-8 text-blue-600" />,
  actions,
  children,
  isAdmin = true,
  loading = false
}) => {
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">로딩 중...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) return null;

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminNavigation />
      <div className="w-full px-4 sm:px-6 lg:px-8 py-8">
        {/* 헤더 섹션 */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center space-x-3 mb-2">
                {icon}
                <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
              </div>
              <p className="text-gray-600">{description}</p>
              <div className="mt-2 inline-flex items-center px-3 py-1 rounded-full text-sm bg-green-100 text-green-800">
                <Shield className="h-4 w-4 mr-1" />
                관리자 권한으로 접근중
              </div>
            </div>
            {actions && (
              <div className="flex items-center gap-3">
                {actions}
              </div>
            )}
          </div>
        </div>

        {/* 콘텐츠 섹션 */}
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
